import { OrderEntity } from 'api/types/entity';
import { UpdateOrderParams } from 'api/types/params';

import { parseOrderParams } from '../../common/helpers';
import { OrderFormType } from '../forms/orderForm';

export const getOrderSubmitData = (
  values: OrderFormType,
  order: OrderEntity
): UpdateOrderParams => ({
  ...parseOrderParams(values),
  executionPeriodInBusinessDays: order.startDate
    ? values.executionPeriodInBusinessDays
    : undefined,
});
